const SteddyStar = ({ className = "" }: { className?: string }) => (
  <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M50 0 C54 38, 62 46, 100 50 C62 54, 54 62, 50 100 C46 62, 38 54, 0 50 C38 46, 46 38, 50 0Z"
      fill="currentColor"
    />
  </svg>
);

export default SteddyStar;
